import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'prop-types';
import { Button, Icon, Dropdown, Menu, Popup } from 'semantic-ui-react';
import SearchInput from '../../containers/search-input';

const openUrl = url => {
  window.open(url, '_blank');
};

export const ViewModes = {
  cardsSmall: 'cards.small',
  cardsLarge: 'cards.large',
  table: 'table.default',
};

const TabActionBar = props => {
  const {
    hasCampaignFilter,
    hasSmallCardsView,
    hasLargeCardsView,
    hasTableView,
    hasActionButton,
    hasSearchBox,
    hasPerPageSelector,
    isSmallCards,
    isLargeCards,
    isTableView,
    actionButtonProps,
    groupByOptions,
    sortByOptions,
    onViewModeChanged,
    onGroupByChanged,
    onSortByChanged,
    helpPageUrl,
    shouldDisableButtons,
    perPageOptions,
    onSearchInputSubmit,
    onSearchCleared,
    onPerPageValueChanged,
    perPage,
    sort,
    onCampaignFilterChanged,
    campaignFilter,
    campaignFilterOptions,
    hasCampaignTypeFilter,
    campaignTypesOptions,
    onCamapignTypeFilterChanged,
  } = props;
  return (
    <Menu icon>
      {
        hasSmallCardsView &&
        <Menu.Item
          disabled={shouldDisableButtons}
          className="dyzio-tab"
          name={ViewModes.cardsSmall}
          active={!shouldDisableButtons && isSmallCards}
          onClick={onViewModeChanged}
        >
          <Icon name="grid layout" />
        </Menu.Item>
      }
      {
        hasLargeCardsView &&
        <Menu.Item
          disabled={shouldDisableButtons}
          className="dyzio-tab"
          name={ViewModes.cardsLarge}
          active={!shouldDisableButtons && isLargeCards}
          onClick={onViewModeChanged}
        >
          <Icon name="block layout" />
        </Menu.Item>
      }
      {
        hasTableView &&
        <Menu.Item
          disabled={shouldDisableButtons}
          className="dyzio-tab"
          name={ViewModes.table}
          active={!shouldDisableButtons && isTableView}
          onClick={onViewModeChanged}
        >
          <Icon name="list layout" />
        </Menu.Item>
      }

      <Menu.Item onClick={() => openUrl(helpPageUrl)}>
        <Popup
          trigger={<Icon name="help circle" color="blue" />}
          content="Click here to find out more about this page and how to use it."
        />
      </Menu.Item>
      <Menu.Menu position="right">
        {
          hasSearchBox &&
          <Menu.Item>
            <SearchInput onSearchCleared={onSearchCleared} onSubmit={onSearchInputSubmit} />
          </Menu.Item>
        }
        {
          hasCampaignTypeFilter && (
            <Dropdown
              onChange={onCamapignTypeFilterChanged}
              text="Type"
              defaultValue="all"
              options={campaignTypesOptions}
              simple
              item
            />
          )
        }
        { groupByOptions &&
        <Dropdown
          disabled={shouldDisableButtons}
          onChange={onGroupByChanged}
          text="Group by"
          options={groupByOptions}
          simple
          item
        />
        }
        {
          sortByOptions &&
            <Dropdown
              disabled={shouldDisableButtons}
              onChange={onSortByChanged}
              text="Sort by"
              options={sortByOptions}
              simple
              value={sort || null}
              item
            />
        }
        {
          hasPerPageSelector &&
          <Dropdown
            disabled={shouldDisableButtons}
            onChange={onPerPageValueChanged}
            simple
            item
            value={perPage}
            options={perPageOptions}
            text="Per page"
          />
        }
        {
          hasCampaignFilter &&
          <Dropdown
            onChange={onCampaignFilterChanged}
            simple
            item
            value={campaignFilter}
            options={campaignFilterOptions}
            text={campaignFilter.value}
          />
        }
        {
          hasActionButton &&
            <Menu.Item>
              <Button icon inverted labelPosition="left" color="pink" onClick={actionButtonProps.onClick}>
                <Icon name="plus" />
                { actionButtonProps.content }
              </Button>
            </Menu.Item>
        }
      </Menu.Menu>
    </Menu>
  );
};

TabActionBar.propTypes = {
  hasSmallCardsView: PropTypes.bool,
  hasLargeCardsView: PropTypes.bool,
  hasTableView: PropTypes.bool,
  hasActionButton: PropTypes.bool.isRequired,
  actionButtonProps: PropTypes.object.isRequired,
  isSmallCards: PropTypes.bool.isRequired,
  isLargeCards: PropTypes.bool.isRequired,
  isTableView: PropTypes.bool.isRequired,
  groupByOptions: PropTypes.array.isRequired,
  sortByOptions: PropTypes.array.isRequired,
  onViewModeChanged: PropTypes.func.isRequired,
  onGroupByChanged: PropTypes.func.isRequired,
  onSortByChanged: PropTypes.func.isRequired,
  onSearchInputSubmit: PropTypes.func,
  helpPageUrl: PropTypes.string.isRequired,
  perPage: PropTypes.number.isRequired,
  shouldDisableButtons: PropTypes.bool,
  hasSearchBox: PropTypes.bool,
  hasPerPageSelector: PropTypes.bool,
  sort: PropTypes.object,
  onPerPageValueChanged: PropTypes.func,
  onSearchCleared: PropTypes.func,
  perPageOptions: PropTypes.array,
  hasCampaignFilter: PropTypes.bool,
  onCampaignFilterChanged: PropTypes.func,
  campaignFilter: PropTypes.string,
  campaignFilterOptions: PropTypes.array,
  hasCampaignTypeFilter: PropTypes.bool,
  campaignTypesOptions: PropTypes.array,
  onCamapignTypeFilterChanged: PropTypes.func,
};

TabActionBar.defaultProps = {
  hasCampaignFilter: false,
  hasSmallCardsView: true,
  hasLargeCardsView: true,
  hasTableView: true,
  shouldDisableButtons: false,
  hasSearchBox: false,
  hasPerPageSelector: false,
  onSearchQueryChanged: null,
  onPerPageChanged: null,
  onPerPageValueChanged: null,
  campaignFilter: 'ACTIVE',
  onCampaignFilterChanged: null,
  onSearchInputSubmit: null,
  onSearchCleared: null,
  sort: null,
  perPageOptions: [],
  campaignFilterOptions: [],
  hasCampaignTypeFilter: false,
  campaignTypesOptions: [],
  onCamapignTypeFilterChanged: _.noop,
};

export default TabActionBar;



/** WEBPACK FOOTER **
 ** ./src/components/tab-action-bar/index.js
 **/